module.exports = __webpack_public_path__ + "img/Data_center.693c8bfb.svg";